import { Component } from '@angular/core';

@Component({
  selector: 'app-health',
  standalone: true,
  templateUrl: './health.component.html',
})
export class HealthComponent {
  status = JSON.stringify({ status: 'Ok' });
}
